import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleCopy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPeopleCopy"><Path fillRule="evenodd" clipRule="evenodd" d="M2 2V18H6V22H22V6H18V2H2ZM16.5 6V3.5H3.5V16.5H6V6H16.5ZM14 16.5C11.7188 16.5 9.77091 18.1607 9 20.5H19C18.2291 18.1607 16.2812 16.5 14 16.5ZM14 15C15.3807 15 16.5 13.8807 16.5 12.5C16.5 11.1193 15.3807 10 14 10C12.6193 10 11.5 11.1193 11.5 12.5C11.5 13.8807 12.6193 15 14 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleCopy;
